import React, { useEffect } from "react";
import { Inbox } from "pages/Messages/Inbox";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { History } from "./History";
import { Notifications } from "./Notifications";
import { Announcements } from "./Announcements";
import { Settings } from "./Settings";
import { getFeatureSetOption, getFeaturesList } from "../../constant";
import  Vdu  from "./VDU";
import { useSelector } from "react-redux";
export const Messages = () => {
  const { siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if(
      getSubnavName === "Inbox" ||
      getSubnavName === "History" ||
      getSubnavName === "Settings" ||
      getSubnavName === "Notifications" ||
      getSubnavName === "Announcements" ||
      getSubnavName === "VDU"
    ){
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"))
    }else{
      mapSideNavTabState.set("Inbox")
      localStorage.setItem("mapSideNavTabState","Inbox")
    }
  },[])

  const sideSubnavData = () => {
    switch (mapSideNavTabState.get()) {
      case "Inbox":
        return <Inbox />;
      case "History":
        return <History />;
      case "Settings":
        return <Settings />;
      case "VDU":
        return <Vdu />;
      case "Notifications":
        return <Notifications />;
      case "Announcements":
        return <Announcements />;
      default:
        return <></>;
    }
  };

  return <>{(mapSideNavTabState.get() !=='Inbox' || (mapSideNavTabState.get() === 'Inbox' && !getFeatureSetOption(
    siteSettingsData && siteSettingsData?.Features,
    getFeaturesList().real_time_tracking
  ))) && sideSubnavData()}</>;
};
